module.exports = "<p>\n  payment works!\n</p>\n"